CalendarDayView = require 'views/calendar/calendar-day-view'

module.exports = class CalendarWeekDayView extends CalendarDayView
  className: 'day-column'



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-week-day-view.coffee